export default {
    appName: "Legacy branding",
    domain: process.env.NODE_ENV == 'production' ? 'https://www.legacybrandingco.com' : 'http://127.0.0.1:8000',
    localUserKey: "yhjcbjmvlyinnkhxhxywxtpurkz"
}
